import React from 'react';
import FieldLabelsList from './FieldLabelsList';

function AvailableColumns() {
  return (
    <FieldLabelsList
      fieldType="dimension"
      paneTitleId="ui-reports.settings.sections.dataModels.pages.availableColumns.lable"
      nameColumnId="ui-reports.sections.dataModels.availableColumns.columns.name"
      paneId="available-columns-settings-pane"
      listId="available-columns-list"
      showCubeSelect
      getItems={(response, cubeName) => {
        const cube = response?.cubes?.find(c => c.name === cubeName);
        return cube?.dimensions || [];
      }}
    />
  );
}

export default AvailableColumns;
